var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('presentacion-modulo-app',{attrs:{"datos":_vm.data}}),_c('audio-player',{ref:"audioPlayer",attrs:{"autoplay":true,"audios":[
  'Modulo 3/AUDIO 01'
  ]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }